import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { LedFrame } from '../ui/LedFrame';
import { usedStockUrl } from '../../data/integrations';
const photo = 'https://cdn.magicpatterns.com/patterns/generated-images/39f0a1c0-1017-4030-883c-bf39fff7cc79.jpg';

/** Banner con foto que invita a ver el stock de usados de VCARS (catálogo aparte del 0 km). */
export function UsedStockCta() {
  return <section className="container-x py-10" aria-labelledby="used-stock-title" data-id="element-810" data-mp="2cvtgfqty3lbo">
      <LedFrame radius={24} data-id="element-811" data-mp="2htuv7zkc8yhc">
        <a href={usedStockUrl} target="_blank" rel="noopener noreferrer" className="group relative block min-h-[320px] overflow-hidden rounded-[24px] bg-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neon-hi sm:min-h-[380px]" data-id="element-812" data-mp="2hv5zs1llya9i">
          <img src={photo} alt="Selección de autos usados en el showroom de VCARS" loading="lazy" className="absolute inset-0 h-full w-full object-cover object-right transition-transform duration-300 ease-out group-hover:scale-[1.04]" data-id="element-813" data-mp="21xe4x6ynt0r" />
          <div className="absolute inset-0 bg-ink/60 sm:bg-ink/25" aria-hidden data-id="element-814" data-mp="3rzhqqwea0ail" />

          <div className="relative flex h-full min-h-[320px] max-w-xl flex-col justify-center p-7 sm:min-h-[380px] sm:p-12" data-id="element-815" data-mp="3mytwm1ur3dk5">
            <h2 id="used-stock-title" className="font-display text-4xl font-black leading-[0.95] tracking-tight text-white sm:text-6xl" data-id="element-816" data-mp="3ix02kcf297sy">
              ¿CONOCÍAS NUESTRO
              <br data-id="element-817" data-mp="397ggyyzyqzue" />
              <span className="text-glow text-neon-hi" data-id="element-818" data-mp="396x96b411ru3">STOCK DE USADOS?</span>
            </h2>
            <p className="mt-4 max-w-sm text-silver" data-id="element-819" data-mp="349x5g6unh165">
              Además de 0 km, en VCARS tenemos usados seleccionados. Es un catálogo aparte, con sus propias unidades y condiciones.
            </p>
            <span className="btn btn-primary mt-7 h-12 w-fit px-6" data-id="element-820" data-mp="2v75qvy6h9paa">
              Ver stock de usados
              <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden data-id="element-821" data-mp="2qa5mrst6uwlt" />
            </span>
          </div>
        </a>
      </LedFrame>
    </section>;
}